<template>
  <div class="pub-content-nav">
    <div class="pub-content-pageHeader">
      <ProjectHeader @change="changeProject" v-if="showProject && isAdmin" />
      <slot name="pageHeader"></slot>
    </div>
    <div class="pub-content-body">
      <div class="pub-page">
        <slot></slot>
        <AdminFooter />
      </div>
    </div>
  </div>
</template>
<script>
import AdminFooter from "@/layout/components/AdminFooter.vue";
import ProjectHeader from "@/components/PublicModals/ProjectHeader";
import { mapState } from "vuex";
export default {
  components: {
    AdminFooter,
    ProjectHeader,
  },
  computed: {
    ...mapState("user", ["isAdmin", "schoolId"]),
  },
  name: "PubPage",
  props: {
    showProject: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  mounted() {
    if (!this.isAdmin) {
      console.log(333);
      this.$emit("changeProject");
    }
  },
  methods: {
    changeProject(data) {
      console.log(data);
      this.$emit("changeProject");
    },
  },
};
</script>

<style lang="less">
// 公用内页
.pub-content-nav {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  .pub-content-pageHeader {
    width: 100%;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.1);
    z-index: 2;
  }
  .pub-content-body {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    .pub-page {
      padding: 20px;
      transition: all 0.3s;
    }
    .pub-card {
      border-radius: 4px;
      background: #fff;
      .box-shadow;
    }
    .page-tabs {
      overflow: visible;
      .ant-tabs-bar {
        border-bottom: none;
        margin: 0;
        margin-left: -1px;
        .ant-tabs-tab {
          border-bottom: none !important;
        }
      }
      .pub-card {
        border-radius: 0 4px 4px 4px;
      }
    }
  }
}
</style>
